import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/company-info/company-info.tsx");
